// extracted by mini-css-extract-plugin
module.exports = {"container":"TitleBanner_container__7dyGu","container__inner":"TitleBanner_container__inner__2vrg5","title":"TitleBanner_title__1C1qv"};